module.exports = __webpack_public_path__ + "static/media/map.d67f86df.svg";